import React from "react";
import styled from "styled-components";

const ModalInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  margin-top: 12px;
  margin-bottom: 4px;
`;

const ModalInfo = ({ children, ...rest }: any) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <ModalInfoWrapper {...rest}>{children}</ModalInfoWrapper>
);

export default ModalInfo;
